import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import { CartBannerImg } from "../../assets/images";

const CartBanner = ({
  header = Text.myCart,
  description = Text.entertainmentPark,
}) => {
  return (
    <CartBannerContainer>
      <BannerTextDiv>
        {/* <MyCartText>{header}</MyCartText> */}
        {/* <MyCartSubText>{description}</MyCartSubText> */}
      </BannerTextDiv>
    </CartBannerContainer>
  );
};

const CartBannerContainer = styled.div`
  height: 20rem;
  background: url(${CartBannerImg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  @media only screen and (max-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  @media only screen and (max-width: 576px) {
    height: 12rem;
    justify-content: flex-start;
    text-align: left;
    // padding: 0 1rem;
  }
`;

const BannerTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  color: ${Colors.white};
  display: flex;
  padding: 0 3rem;
  justify-content: center;
  // align-items: flex-start;
  height: 100%;
  @media only screen and (max-width: 576px) {
    /* background-color: rgba(0, 0, 0, 0.4); */
    width: 100%;
    padding: 0 4rem;
  }
`;
const MyCartText = styled.span`
  font-size: 3rem;
  font-weight: 700;
  color: ${Colors.white};
  @media only screen and (max-width: 1024px) {
    font-size: 2rem;
  }
  @media only screen and (max-width: 576px) {
    font-size: 1.625rem;
  }
`;
const MyCartSubText = styled(MyCartText)`
  font-weight: 400;
  font-size: 2rem;
  @media only screen and (max-width: 1024px) {
    font-size: 1.125rem;
  }
`;

export default CartBanner;
